import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { filter as getAllEntityItems } from '@/services/api/resources/entityItem';
import { filter as getAllGroups } from '@/services/api/resources/group';
import { filter as getAllUsers } from '@/services/api/resources/user';
import { filter as getAllCategories } from '@/services/api/resources/category';
import { filter as getAllChecklists } from '@/services/api/resources/checklist';
import { filter as getAllSensors } from '@/services/api/resources/sensor';
import { filter as getAllSections } from '@/services/api/resources/section';
import { filterListToOptions, filterEntityFolderToOptions, sequence } from '@/ui/helpers/uiHelper';
import { list as getAllEntityFoldersWithEntityItems, entityFolderDefaultQuery } from '@/services/api/resources/entityFolder';
import { SelectOptions } from '@/ui/types';

export function useFilters() {
  const entityItems = ref([] as SelectOptions);
  const groups = ref([] as SelectOptions);
  const users = ref([] as SelectOptions);
  const categories = ref([] as SelectOptions);
  const checklists = ref([] as SelectOptions);
  const sensors = ref([] as SelectOptions);
  const sections = ref([] as SelectOptions<string>);
  const entityFolders = ref([] as SelectOptions<string>);

  const getFilters = useTask(
    () => sequence(
      getAllGroups(),
      getAllEntityItems(),
      getAllUsers(),
      getAllCategories(),
      getAllChecklists(),
      getAllSensors(),
      getAllSections(),
      getAllEntityFoldersWithEntityItems(entityFolderDefaultQuery()),
    ),
    ([
      groupList,
      entityItemList,
      userList,
      categoryList,
      checklistList,
      sensorList,
      sectionList,
      entityFolderList,
    ]) => {
      entityItems.value = filterListToOptions(entityItemList);
      groups.value = filterListToOptions(groupList);
      users.value = filterListToOptions(userList);
      categories.value = filterListToOptions(categoryList);
      checklists.value = filterListToOptions(checklistList);
      sensors.value = filterListToOptions(sensorList);
      sections.value = filterListToOptions(sectionList);
      entityFolders.value = filterEntityFolderToOptions(entityFolderList);
    },
  );

  return {
    getFilters,
    entityItems,
    entityFolders,
    groups,
    users,
    categories,
    checklists,
    sensors,
    sections,
  };
}
